import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';
// import shopLogo from '../../assets/shop-logo.png';        // zamijeni s tvojom stvarnom putanjom
// import salonLogo from '../../assets/salon-logo.png';      // zamijeni s tvojom stvarnom putanjom
// import logo from "../images/BB_Crni.png"
import shopLogo from "../../../images/BB_Crni.png"
import salonLogo from "../../../images/logo_salon.png"


const LandingPage = () => {
    const navigate = useNavigate();

    const goToShop = () => {
        navigate('/home'); // ili '/' ako ti je to ruta za dućan
    };

    const goToSalon = () => {
        window.location.href = 'https://ninahrsakbeautyboutique.hr';
    };

    return (
        <div className="landing-container font-tiskani">
            {/*<h1 className="landing-title">Dobrodošli</h1>*/}
            <div className="logo-buttons">
                <div className="logo-wrapper" onClick={goToShop}>
                    <img src={shopLogo} alt="Webshop" />
                    <p>Webshop</p>
                </div>
                <div className="logo-wrapper" onClick={goToSalon}>
                    <img src={salonLogo} alt="Salon stranica" />
                    <p>Salon</p>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
